// This is the root reducer of the feature. It is used for:
//   1. Load reducers from each action in the feature and process them one by one.
//      Note that this part of code is mainly maintained by Rekit, you usually don't need to edit them.
//   2. Write cross-topic reducers. If a reducer is not bound to some specific action.
//      Then it could be written here.
// Learn more from the introduction of this approach:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da.

import initialState from './initialState'
import { LOGOUT_USER } from '../../common/redux/constants'
import { reducer as getReportReducer } from './getReport'
import { reducer as clearReportReducer } from './clearReport'
import { reducer as takingCarManagementFieldsReducer } from './takingCarManagementFields'
import { reducer as getCarLotOptionsReducer } from './getCarLotOptions/reducer'
import { reducer as saveTakingCarManagment } from './saveTakingCarManagment/reducer'
import { reducer as getBuyPossibleActions } from './getBuyPossibleActions/reducer'
import { reducer as getSellPossibleActions } from './getSellPossibleActions/reducer'
import { reducer as getDataTabsReducer } from './getDataTabs/reducer'
import { reducer as cleanCardFormReducer } from './cleanCardForm';
import { reducer as saveTakingCarManagementBothReducer } from './saveTakingCarManagementBoth/reducer'
import { reducer as updateCommentReducer } from './updateComment/reducer'

const reducers = [
  getReportReducer,
  clearReportReducer,
  takingCarManagementFieldsReducer,
  getCarLotOptionsReducer,
  saveTakingCarManagment,
  getBuyPossibleActions,
  getSellPossibleActions,
  getDataTabsReducer,
  cleanCardFormReducer,
  saveTakingCarManagementBothReducer,
  updateCommentReducer
]

export default function reducer(state = initialState, action = '') {
  let newState
  if (action.type === LOGOUT_USER) {
      newState = initialState
  }
  else{
    newState = state
  }
  return reducers.reduce((s, r) => r(s, action), newState)
}
